import * as yup from 'yup';
import { TFunction } from 'i18next';
import { MAX_TITLE_LENGTH } from '../../constants';
import { FieldValidator } from '../../types';

export const TITLE_REGEX = /[^A-Za-z0-9_$!?:.,' +\-=~`@#%^*[\]()/{}\\|]/;

export const validator: FieldValidator = ({ params: { isPresetsForm } }, t: TFunction) => {
  if (isPresetsForm) {
    return yup.object({
      title: yup
        .string()
        .trim()
        .max(MAX_TITLE_LENGTH, t('deviationSubmit.validation.error.tooLong'))
        .test(
          'title',
          t('deviationSubmit.validation.error.title.invalid'),
          v => !TITLE_REGEX.test(v)
        ),
    });
  }

  return yup.object({
    title: yup
      .string()
      .required(t('deviationSubmit.validation.error.title.required'))
      .test('title', t('deviationSubmit.validation.error.title.invalid'), v => !TITLE_REGEX.test(v))
      .max(MAX_TITLE_LENGTH, t('deviationSubmit.validation.error.tooLong')),
  });
};
